// extracted by mini-css-extract-plugin
export default {"saving":"Loading_saving__GmrrM"};